import React from 'react';
export function CredibilitySection() {
  return <section className="bg-[#FDF8F0] py-12 md:py-16 px-5" data-id="element-9">
      <div className="max-w-2xl mx-auto text-center" data-id="element-10">
        <h2 className="text-xl md:text-2xl font-bold text-[#2D1F0E] mb-4" data-id="element-11">
          Una guía creada para el momento real
        </h2>
        <p className="text-[0.95rem] md:text-base text-[#6B5D4F] leading-relaxed" data-id="element-12">
          Protocolo SOS fue creado para mamás que necesitan saber qué hacer
          cuando su hijo entra en crisis emocional o sensorial, especialmente en
          público o en momentos de alta presión. Está diseñado en español, con
          pasos claros, prácticos y fáciles de aplicar.
        </p>
      </div>
    </section>;
}